import axiosInstance from "@/services/axios"
import { User } from "@/types"
import { useQuery } from "@tanstack/react-query"
import { useCallback } from "react"

export type RetrieveUsersErrorResponse = {
  message: string
}

export type RetrieveUsersSuccessResponse = User[]

const useRetrieveUsers = () => {
  const fetchData = useCallback(async () => {
    const res = await axiosInstance.get(`/api/users`)

    return res.data
  }, [])

  const { status, data, error, isFetching, isPlaceholderData, refetch } =
    useQuery<unknown, RetrieveUsersErrorResponse, RetrieveUsersSuccessResponse>(
      {
        queryKey: [`/api/users`],
        queryFn: () => fetchData(),
      }
    )

  return {
    status,
    data,
    error,
    isFetching,
    isPlaceholderData,
    refetch,
  }
}

export default useRetrieveUsers
